import styled from 'styled-components'
import { CsvPreviewGrid, ICsvPreviewGridProps } from './CsvPreviewGrid'

type IProps = ICsvPreviewGridProps

const CsvPreview = (props: IProps) => {
  return (
    <Section>
      <h3>Preview Column Settings on Sample Data</h3>
      <section className="preview-panel">
        <CsvPreviewGrid
          columnSettings={props.columnSettings}
          fileCenterSampleData={props.fileCenterSampleData}
          justSniff={props.justSniff}
        />
      </section>
    </Section>
  )
}

const Section = styled.section`
  height: 100%;

  .preview-panel {
    height: 100%;
    background-color: ${({ theme }) => theme.colors.info.lightest};
    padding: 0.75rem 1rem;
  }
`

export { CsvPreview }
